import { Stack, Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useLanguage } from '@xolv-mybrightlink/common';

export const LanguageSetting = () => {
  const { language: currentLanguage, updateLanguage } = useLanguage();

  const selectedStyling = {
    fontWeight: 600,
    color: 'black',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
    },
  };

  const unSelectedStyling = {
    fontWeight: 400,
    color: 'action.active',
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'underline',
    },
  };

  return (
    <Stack direction='row' alignItems='center'>
      <Button
        variant={'text'}
        disableElevation
        onClick={() => updateLanguage('en')}
        sx={currentLanguage == 'en' ? selectedStyling : unSelectedStyling}
      >
        <FormattedMessage id='account.setting.language.name.english' />
      </Button>
      <Typography sx={{ color: 'action.active', mx: 4 }}>|</Typography>
      <Button
        variant={'text'}
        disableElevation
        onClick={() => updateLanguage('es')}
        sx={currentLanguage == 'es' ? selectedStyling : unSelectedStyling}
      >
        <FormattedMessage id='account.setting.language.name.spanish' />
      </Button>
    </Stack>
  );
};
